import { render, staticRenderFns } from "./MapCompetitionPoint.vue?vue&type=template&id=5b6fe7e6&"
import script from "./MapCompetitionPoint.vue?vue&type=script&lang=js&"
export * from "./MapCompetitionPoint.vue?vue&type=script&lang=js&"
import style0 from "./MapCompetitionPoint.vue?vue&type=style&index=0&id=5b6fe7e6&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/vhosts/dostartu.pl/app.startzone.online/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5b6fe7e6')) {
      api.createRecord('5b6fe7e6', component.options)
    } else {
      api.reload('5b6fe7e6', component.options)
    }
    module.hot.accept("./MapCompetitionPoint.vue?vue&type=template&id=5b6fe7e6&", function () {
      api.rerender('5b6fe7e6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/MapCompetitionPoint.vue"
export default component.exports